'use client';
import Image from 'next/image';
import LanguageSelector from '@/components/public/i18n/LanguageSelector';
import { useI18n } from '@/components/public/i18n/LocaleProvider';
import Link from '@/components/public/i18n/LocalizedLink';
import { UNIVERSES as SOURCE_UNIVERSES, type UniverseId } from '@/lib/public/universes';
import { Arrow } from './Icons';
import PublicNavigation from './PublicNavigation';
import ElinaAccess from '../elina/ElinaAccess';
import './universes.css';
export function PublicHeader({ active }: { active?: UniverseId }) {
  const { t, href, content, locale } = useI18n();
  const UNIVERSES = content(SOURCE_UNIVERSES);

  return (
    <header className="u-header eco-header">
      <Link href={href("/")} className="u-brand" aria-label={t("Accueil RDV-Partners")}>
        <Image src="/assets/universes/logo.png" width={66} height={66} sizes="(max-width: 760px) 44px, 66px" quality={85} alt="" />
        <span>
          RDV<span className="u-brand-light">PARTNERS</span>
          <small>{t("Votre ambition. Notre engagement.")}</small>
        </span>
      </Link>
      <PublicNavigation />
      <LanguageSelector />
      <Link className="u-client-link" href={href("/client/login")}>
        {t("Mon espace ")}<Arrow diagonal />
      </Link>
    </header>
  );
}
export function PublicFooter() {
  const { t, href, content, locale } = useI18n();


  return (
    <footer className="u-footer">
      <span>© {new Date().getFullYear()} RDV-Partners</span>
      <span>{t('Ingénierie digitale · Méthode SX · Expertise métier')}</span>
      <Link href="/ecosysteme">{t('Écosystème')}</Link>
      <Link href="/a-propos">{t('À propos')}</Link>
      <Link href={href("/partenaires")}>{t("Partenaires")}</Link>
      <Link href={href("/direction")}>{t("Direction")}</Link>
      <Link href={href("/")}>
        {t("Accueil RDV-Partners ")}<Arrow diagonal />
      </Link>
    </footer>
  );
}
export default function PublicShell({
  active,
  children,
  portal = false,
}: {
  active?: UniverseId;
  children: React.ReactNode;
  portal?: boolean;
}) {
  const { t, href, content, locale } = useI18n();


  return (
    <div className={`rdv-public${portal ? ' rdv-public-portal' : ''}`}>
      <a className="u-skip" href={href("#contenu")}>
        {t("Aller au contenu")}</a>
      <PublicHeader active={active} />
      {children}
      <ElinaAccess />
      <PublicFooter />
    </div>
  );
}



